import React from "react";
import { UserSearch } from "../../components/userSearch";
import AddressBlock from "../../components/addAddress/addressBlock";
import { addressData } from "../../components/addAddress/addressData";

export const ExistingUser = () => {
  return (
    <>
      <UserSearch showDetails />
      <div className="sm:flex flex-wrap m-5">
        {addressData.map((address, index) => (
          <AddressBlock
            key={index}
            {...address}
            isLogoBlockVisible={index === addressData.length - 1}
            isAddressBlockVisible
          />
        ))}
      </div>
    </>
  );
};
